import { Link } from "react-router-dom";
import { BOOKING_URL, GIFT_URL, PACKAGES_URL, CHERRY_URL, PHONE_DISPLAY, PHONE_TEL, FAX_DISPLAY, EMAIL, ADDRESS_LINE1, ADDRESS_LINE2, MAPS_URL, HOURS } from "../data/site";
import { CATEGORIES } from "../data/services";
import { TREATMENT_PAGES } from "../data/treatment-pages";
import { SocialLinks } from "./SocialLinks";

const Col = ({ title, children, className = "" }) => (
  <div className={className}>
    <p className="mb-6 text-[10px] uppercase tracking-[0.3em] text-neutral-500">{title}</p>
    <ul className="space-y-3 text-sm font-light text-neutral-300">{children}</ul>
  </div>
);

const A = ({ href, children, testid }) => (
  <li>
    <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid={testid} className="transition-colors hover:text-white">
      {children}
    </a>
  </li>
);

export const Footer = () => (
  <footer className="bg-neutral-950 text-white" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-4 py-24 md:px-8">
      <div className="mb-20 flex flex-col items-center text-center">
        <Link to="/" onClick={() => window.scrollTo(0, 0)} className="flex flex-col items-center" data-testid="footer-logo-link">
          <img src="/logo-white.png" alt="Lux Veritae Skin Spa" className="h-36 w-auto" />
          <span className="font-display mt-6 text-3xl tracking-[0.2em] text-white md:text-4xl">LUX VERITAE SKIN SPA</span>
        </Link>
        <p className="font-display mt-6 text-xl italic text-neutral-300" data-testid="footer-slogan">Confident enough to leave the lights on.</p>
        <SocialLinks className="mt-10" />
      </div>
      <div className="grid grid-cols-2 gap-12 md:grid-cols-4">
        <Col title="Treatments">
          {CATEGORIES.map((c) => (
            <li key={c.id}>
              <Link to={`/treatments#${c.id}`} className="transition-colors hover:text-white" data-testid={`footer-cat-${c.id}`}>{c.name}</Link>
            </li>
          ))}
          {TREATMENT_PAGES.map((p) => (
            <li key={p.slug}>
              <Link to={`/treatments/${p.slug}`} className="transition-colors hover:text-white" data-testid={`footer-tp-${p.slug}`}>{p.name}</Link>
            </li>
          ))}
        </Col>
        <Col title="Reserve">
          <A href={BOOKING_URL} testid="footer-book">Book Online</A>
          <li><Link to="/contact" className="transition-colors hover:text-white" data-testid="footer-consult">Request a Consultation</Link></li>
          <li><Link to="/contact-us" className="transition-colors hover:text-white" data-testid="footer-contact-us">Contact Us</Link></li>
          <A href={GIFT_URL} testid="footer-gift">Gift Cards</A>
          <A href={PACKAGES_URL} testid="footer-packages">Memberships & Packages</A>
          <A href={CHERRY_URL} testid="footer-cherry">Cherry Financing</A>
        </Col>
        <Col title="Contact">
          <A href={`tel:${PHONE_TEL}`} testid="footer-phone">{PHONE_DISPLAY}</A>
          <li className="text-neutral-400" data-testid="footer-fax">Fax {FAX_DISPLAY}</li>
          <A href={`sms:${PHONE_TEL}`} testid="footer-text">Text Us</A>
          <A href={`mailto:${EMAIL}`} testid="footer-email">{EMAIL}</A>
          <A href={MAPS_URL} testid="footer-address">{ADDRESS_LINE1}<br />{ADDRESS_LINE2}</A>
        </Col>
        <Col title="Hours" className="col-span-2 md:col-span-1">
          <li data-testid="footer-hours"><span className="block">Mon–Fri 10am–8pm</span><span className="block whitespace-nowrap">Sat 8am–8pm · Sun Closed</span></li>
          <li><Link to="/glow" className="transition-colors hover:text-white" data-testid="footer-glow-link">Quick Consultation Request</Link></li>
          <li><Link to="/new-client-offer" className="transition-colors hover:text-white" data-testid="footer-landing-link">New Client Offer · 10% Off</Link></li>
          <li><Link to="/blog" className="transition-colors hover:text-white" data-testid="footer-blog-link">The Journal</Link></li>
          <li><Link to="/about" className="transition-colors hover:text-white" data-testid="footer-about-link">About Us</Link></li>
          <li><Link to="/memberships" className="transition-colors hover:text-white" data-testid="footer-memberships-link">Memberships</Link></li>
          <li><Link to="/private-consultation" className="transition-colors hover:text-white" data-testid="footer-private-link">Private Consultation</Link></li>
        </Col>
      </div>
      <div className="mt-20 flex flex-col justify-between gap-4 border-t border-neutral-800 pt-8 text-[11px] text-neutral-500 md:flex-row">
        <p>© {new Date().getFullYear()} Lux Veritae Skin Spa. All rights reserved.</p>
        <p>All medical services are provided under the supervision of a licensed medical provider.</p>
      </div>
    </div>
  </footer>
);
